import { render, staticRenderFns } from "./CardScheduleInstallation.vue?vue&type=template&id=798f2664&scoped=true&"
import script from "./CardScheduleInstallation.vue?vue&type=script&lang=js&"
export * from "./CardScheduleInstallation.vue?vue&type=script&lang=js&"
import style0 from "./CardScheduleInstallation.vue?vue&type=style&index=0&id=798f2664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798f2664",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
